// extracted by mini-css-extract-plugin
export var grid = "_2g-0";
export var span1 = "_2g-2";
export var span10 = "_2g-b";
export var span10L = "_2g-z";
export var span10M = "_2g-n";
export var span10Xl = "_2g-1b";
export var span11 = "_2g-c";
export var span11L = "_2g-10";
export var span11M = "_2g-o";
export var span11Xl = "_2g-1c";
export var span12 = "_2g-d";
export var span12L = "_2g-11";
export var span12M = "_2g-p";
export var span12Xl = "_2g-1d";
export var span1L = "_2g-q";
export var span1M = "_2g-e";
export var span1Xl = "_2g-12";
export var span2 = "_2g-3";
export var span2L = "_2g-r";
export var span2M = "_2g-f";
export var span2Xl = "_2g-13";
export var span3 = "_2g-4";
export var span3L = "_2g-s";
export var span3M = "_2g-g";
export var span3Xl = "_2g-14";
export var span4 = "_2g-5";
export var span4L = "_2g-t";
export var span4M = "_2g-h";
export var span4Xl = "_2g-15";
export var span5 = "_2g-6";
export var span5L = "_2g-u";
export var span5M = "_2g-i";
export var span5Xl = "_2g-16";
export var span6 = "_2g-7";
export var span6L = "_2g-v";
export var span6M = "_2g-j";
export var span6Xl = "_2g-17";
export var span7 = "_2g-8";
export var span7L = "_2g-w";
export var span7M = "_2g-k";
export var span7Xl = "_2g-18";
export var span8 = "_2g-9";
export var span8L = "_2g-x";
export var span8M = "_2g-l";
export var span8Xl = "_2g-19";
export var span9 = "_2g-a";
export var span9L = "_2g-y";
export var span9M = "_2g-m";
export var span9Xl = "_2g-1a";
export var stretch = "_2g-1";